import React from 'react';
import { Link } from 'react-router-dom';
import mainLogo from '../../Assets/images/main-logo.svg';
import { Routes } from '../../constants/RouteConstants';
import { LanguageConstants } from '../../constants/LanguageConstants';
import LanguageDropdown from './LanguageDropdown';
import '../home/landing.scss';
import { getFromStorage } from '../../utils/Helper';
import { StorageConstant } from '../../constants/Constants';
import { useContactSupportModal } from '../../context/ContactSupportModalContext';

/**
 * Marketing-style footer (same as home landing) for flows that should not use the compact main-footer.
 */
function LandingFooter() {
  const { openContactSupport } = useContactSupportModal();
  const hasAccessToken = Boolean(getFromStorage({ key: StorageConstant?.ACCESS_TOKEN }));
  const trendingProductsRoute = hasAccessToken ? '/product' : Routes.Login;

  return (
    <footer className="landing-footer check-2">
      <div className="landing-footer__grid">
        <div className="landing-footer__brand">
          <img
            src={mainLogo}
            alt="Quote N Buy"
            className="landing-footer__logo-img"
            width={180}
            height={44}
          />
        </div>
        <div>
          <h3 className="landing-footer__col-title">{LanguageConstants?.LANDING_FOOTER_COMPANY}</h3>
          <ul className="landing-footer__links">
            <li>
              <Link to="/cms/about-us">{LanguageConstants?.ABOUTUS}</Link>
            </li>
            <li>
              <Link to={{ pathname: '/', hash: 'landing-reviews' }}>
                {LanguageConstants?.LANDING_FOOTER_REVIEWS}
              </Link>
            </li>
            <li>
              <Link to={trendingProductsRoute}>{LanguageConstants?.FOOTER_TRENDING_PRODUCTS}</Link>
            </li>
            <li>
              <Link to={Routes.Faq}>{LanguageConstants?.FAQS}</Link>
            </li>
          </ul>
        </div>
        <div>
          <h3 className="landing-footer__col-title">{LanguageConstants?.LANDING_FOOTER_FOLLOW}</h3>
          <ul className="landing-footer__links">
            <li>
              <a href="https://www.instagram.com/quotenbuy_/" target="_blank" rel="noopener noreferrer">
                Instagram
              </a>
            </li>
            <li>
              <a href="https://www.facebook.com/profile.php?id=61592265694819" target="_blank" rel="noopener noreferrer">
                Facebook
              </a>
            </li>
            <li>
              <a href="https://www.tiktok.com/@quotenbuy?lang=en" target="_blank" rel="noopener noreferrer">
                TikTok
              </a>
            </li>
            <li>
              <a href="https://x.com/QuoteNbuy" target="_blank" rel="noopener noreferrer">
                X
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/@QuoteNbuy" target="_blank" rel="noopener noreferrer">
                YouTube
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/company/110748100/admin/page-posts/published/" target="_blank" rel="noopener noreferrer">
                LinkedIn
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h3 className="landing-footer__col-title">{LanguageConstants?.LANDING_FOOTER_GET_APP}</h3>
          <div className="landing-footer__apps">
            <a
              className="landing-footer__app-btn"
              href="https://play.google.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              {LanguageConstants?.LANDING_FOOTER_GOOGLE_PLAY}
            </a>
            <a
              className="landing-footer__app-btn"
              href="https://apps.apple.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              {LanguageConstants?.LANDING_FOOTER_APP_STORE}
            </a>
          </div>
        </div>
        <div className="landing-footer__contact-col">
          <button type="button" className="landing-footer__contact" onClick={openContactSupport}>
            {LanguageConstants?.FOOTER_CONTACT_SUPPORT}
            <span aria-hidden>↗</span>
          </button>
        </div>
      </div>
      <div className="landing-footer__bottom">
        <div className="landing-footer__lang">
          <LanguageDropdown instanceId="langDropdownFooter" />
        </div>
        <div className="landing-footer__legal">
          <span>{LanguageConstants?.COPYRIGHT}</span>
          <span aria-hidden>|</span>
          <Link to="/cms/privacy-policy">{LanguageConstants?.PRIACYPOLICY}</Link>
          <span aria-hidden>|</span>
          <Link to="/cms/terms-and-conditions">{LanguageConstants?.TERMS}</Link>
        </div>
      </div>
    </footer>
  );
}

export default LandingFooter;
